import { namespacedConsts } from '../../jsCore/utils/object';
export const FRESH8_ACTION_TYPES = namespacedConsts({
  DISPLAY_POPUP: true,
  HIDE_POPUP: true,
  DISPLAY_FLOATING_BUTTON: true,
});
function displayPopup(){
  return (dispatch, getState) => {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_POPUP,
      state: {
        isPopupVisible: true,
      }
    });
  };
}
function hidePopup(){
  return (dispatch, getState) => {
    dispatch({
      type: FRESH8_ACTION_TYPES.HIDE_POPUP,
      state: {
        isPopupVisible: false,
      }
    });
  };
}
function displayFloatingButton(){
  return (dispatch, getState) => {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_FLOATING_BUTTON,
      state: {
        isFloatingButtongVisible: true,
      }
    });
  };
}
export const actions = { displayPopup, hidePopup, displayFloatingButton, FRESH8_ACTION_TYPES };


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fresh8/fresh8Actions.js